import React, { useEffect, memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { message } from 'antd';

import styles from './PinPop.module.less';
import { PCStoreJsBridge } from '../nativeapi';
import { logging } from '../actions/log';
import { localKeys, cacheKeys } from '../constants/storageKeys';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

// export default function PinPop() {
export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const [checked, setChecked] = useState(false);

  const handleCheck = useCallback(isChecked => {
    // 快捷方式弹窗 不再弹出
    dispatch(
      logging({
        category: 'C',
        action: 'Shortcut_Check',
        label: '',
        param2: {
          source: 'Shortcut',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: isChecked ? '1' : '0',
        },
      }),
    );
    setChecked(!isChecked);
    localStorage.setItem(localKeys.SHOW_PIN_NO_MORE, !isChecked);
  }, []);

  const handleClose = useCallback(
    flag => {
      // 快捷方式弹窗 取消
      dispatch(
        logging({
          category: 'C',
          action: flag ? 'Shortcut_Close' : 'Shortcut_Cancel',
          label: '',
          param2: {
            source: 'Shortcut',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      PCStoreJsBridge.closeWindow();
    },
    [dispatch],
  );

  const handleCloseWithPin = useCallback(() => {
    // 快捷方式弹窗 创建
    dispatch(
      logging({
        category: 'C',
        action: 'Shortcut_Create',
        label: '',
        param2: {
          source: 'Shortcut',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );

    // 创建桌面图标
    PCStoreJsBridge.pinDesktopIcon();

    // 变态的产品需求，关闭弹框偷偷创建右键菜单 v6.4 2020-11-5
    PCStoreJsBridge.settingRightMenu({ enable: true, source: 2 }).then(ret3 => {
      if (ret3.succ === 'true') {
        const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
        localStorage.setItem(
          cacheKeys.START_INFO,
          JSON.stringify({ ...startInfo, rightKeyMenuStatus: 1 }),
        );
      } else {
        // message.info('软件快捷方式右键添加“强力卸载此软件”选项，设置失败');
      }
    });

    // 变态的产品需求，关闭弹框偷偷创建商店磁铁 v6.5 2020-12-9
    PCStoreJsBridge.settingPCStoreTile({ enable: true, source: 2 }).then(ret4 => {
      if (ret4.succ !== true) {
        // message.info('软件快捷方式创建磁铁失败');
      }
    });

    /**
     * v6.5改为调用settingPCStoreTile()接口后，客户端自己关闭商店 修改时间： 2020-12-18
     * 为了保险起见，防止settingPCStoreTile()接口调用失败，所以5秒钟之后调用closeWindow()
     */
    setTimeout(() => {
      PCStoreJsBridge.closeWindow();
    }, 5000);
  });

  useEffect(() => {
    // 快捷方式弹窗 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Shortcut',
        label: '',
        param2: {
          source: 'Shortcut',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.pinpop}>
      <div className="header">
        <span className="title">温馨提示</span>
        <span className="close iconfont icon-close" onClick={() => handleClose(true)} />
      </div>
      <div className="message">创建系统快捷方式，可更便捷的下载、管理软件，是否创建</div>
      <div className="btn-wrapper">
        <span className="btn_primary" onClick={() => handleCloseWithPin()}>
          确定
        </span>
        <span className="btn_default" onClick={() => handleClose()}>
          取消
        </span>
      </div>
      <div className="check" onClick={() => handleCheck(checked)}>
        {checked ? <div className="checked" /> : <div className="nochecked" />}
        <span className="text">不再弹出</span>
      </div>
    </div>
  );
});
